export default "__VITE_ASSET__DnSiPKc9__"